module.exports = __webpack_public_path__ + "assets/media/3.f0deb38e.wav";